/* eslint-disable */
/**
 * 乾坤天地游戏处理
 */
function fnClientInfo(k) {
  if (!window.clientInfo) {
    return
  }
  let wci = JSON.parse(window.clientInfo)
  if (wci[k]) {
    return wci[k]
  } else {
    return ''
  }
}
function fnOpen(o, vm) {
  let openType = o.openType || o.open_type || 1
  switch (openType) {
    // 1|游戏，2|内容，3|无操作，4|外跳，5|进游戏最新服，6|启端
    case 1:
    case 5:
    case 6:
      if (
        // 网吧环境
        fnClientInfo('gid') &&
        Number(fnClientInfo('gid')) < 99999999 &&
        Number(fnClientInfo('gid')) > 1
      ) {
        let url = o.launch
        window.gameexist = gameexist
        if (window.gameexist.provide && window.gameexist.provide == 1) {
          // 游戏资源存在
          if (url.indexOf('?') > -1) {
            url = url + '&ts='
          } else {
            url = url + '?ts='
          }
          new Image(1, 1).src = url + Date.now()
          vm.Toast({
            content: '正在启动游戏，请稍候。',
            time: 5000
          })
        } else {
          // 游戏资源不存在则下载资源
          vm.fnCefGameBox({
            method: 'clientOpenBrowser',
            data: {
              url: o.downloadurl,
              type: 1
            }
          })
        }
      } else {
        // 非网吧环境
        vm.fnCefGameBox({
          method: 'clientOpenBrowser',
          data: {
            url: o.downloadurl,
            type: 1
          }
        })
      }
      break
    case 2:
      vm.fnCefGameBox({
        method: 'clientOpenWnd',
        data: {
          url: o.url,
          type: 0
        },
        success: res => {
          vm.Storage.set('wndBrowser', 1, res => {})
        }
      })
      break
    case 4:
      vm.fnCefGameBox({
        method: 'clientOpenBrowser',
        data: {
          url: o.url,
          type: 1
        }
      })
      break
  }
}

export default fnOpen
